import { inject } from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { icons } from "./icons";

export class IconRegistry {
    private iconRegistry = inject(MatIconRegistry);
    private sanitizer = inject(DomSanitizer);

    constructor() {
        //iconRegistry.setDefaultFontSetClass('material-icons-outlined'); // CHANGE BEHAVIOUR FOR ALL ICONS (<mat-icon fontIcon/> DOESN'T WORK => USE <mat-icon>icon_name</mat-icon> INSTEAD)

        for(const [iconName, iconPath] of Object.entries(icons)) {
            this.iconRegistry.addSvgIcon(iconName, this.sanitizer.bypassSecurityTrustResourceUrl(iconPath));
        }
    }
}